//  We need this before our scripts (this will expose Size Matter's configuration options):
!function (a) { a._empty = a._empty || [], a._beforeRender = a._beforeRender || [], a._afterRender = a._afterRender || [], a._renderedAll = a._renderedAll || [], a._overrideContent = a._overrideContent || function (a) { return a.content }, a.onEmpty = function (b) { b && a._empty.push(b) }, a.onBeforeRender = function (b) { b && a._beforeRender.push(b) }, a.onAfterRender = function (b) { b && a._afterRender.push(b) }, a.onRenderedAll = function (b) { b && a._renderedAll.push(b) }, a.overrideCellContent = function (b) { a._overrideContent = b } }(window.eastsideco_sizeGuides || (window.eastsideco_sizeGuides = {}));

// Here we're mixing a callback that detects when the charts are finished rendering
// and a snippet from the SizeMatters support team.
document.addEventListener("DOMContentLoaded", function () {
    var SizeMatters = window.eastsideco_sizeGuides;
    SizeMatters.onRenderedAll(function (data) {
        var button = document.querySelector('[data-app="eastsideco_sizeGuides"] button, [data-app="eastsideco_sizeGuides"] a');
        var modal_close = document.querySelector(".modal_close");
        var modal_background = document.querySelector(".modal_background");
        var element = document.body.querySelector(".esc-size-guide--popup");
        var body = document.getElementsByTagName("body")[0];

        modal_close.addEventListener("click", event => {
            body.style.overflow = "unset";
        });

        modal_background.addEventListener("click", event => {
            body.style.overflow = "unset";
        })

        button.addEventListener("click", event => {
            body.style.overflow = "hidden";
        });

        button.addEventListener("click", event => {
            if (element.style.display === "none") {
                body.style.overflow = "unset";
            }
        });
    });
});

// By default, PDP badges are injected with position: absolute !important in the inline style.
// This observer removes that inline style, so it can be positioned correctly.
// THis mutation observer is also responsible for setting the z-index of #attentive_overlay when the inline styles are injected, to prevent z-index issues
const injectionObserver = new MutationObserver(function (mutationsList) {
    for (const mutation of mutationsList) {
        if (mutation.type === 'childList') {
            for (node of mutation.addedNodes) {
                if (node.classList && (node.classList.contains('bss-pb-frontend') || node.classList.contains('bss_pb_img'))) {
                    const badgeContainer = node.querySelector('.bss-pb-frontend');
                    if (badgeContainer) {
                        badgeContainer.style.position = 'relative';
                    }
                } else if (node.classList && node.classList.contains('qimify-minicart-popup-wrapper')) {
                    const oldMinicartBanner = node.querySelector('.minicart-banner');
                    if (oldMinicartBanner) {
                        oldMinicartBanner.remove();
                    }
                    const minicartItems = node.querySelector('.qimify-minicart-items');
                    const minicartBanner = document.querySelector('.minicart-banner');
                    if (minicartItems && minicartBanner) {
                        const newBanner = minicartBanner.cloneNode(true);
                        minicartItems.appendChild(newBanner);
                    }
                    break;
                }
            }
        } else if (mutation.type === 'attributes') {
            if (mutation.target.id === 'attentive_overlay' && mutation.attributeName === 'style') {
                mutation.target.style.zIndex = 700; // Minimum z-index to order overlay above product grid + site header
            }
        }
    }
});
injectionObserver.observe(document, { attributes: true, childList: true, characterData: false, subtree: true });

const sizeGuideWrapper = document.querySelector('.site-footer-block-content [data-app="eastsideco_sizeGuides"]');
if (sizeGuideWrapper) {
    const sizeGuideObserver = new MutationObserver(function (mutationsList, observer) {
        for (const mutation of mutationsList) {
            if (mutation.type === 'childList') {
                $(mutation.target.closest('.site-footer-block-content').previousElementSibling).show();
                observer.disconnect();
                break;
            }
        }
    });
    sizeGuideObserver.observe(sizeGuideWrapper, { attributes: false, childList: true, characterData: false, subtree: true });
}

$('.accordion').accordion({ heightStyle: 'panel' });

/**
 * Module for declaring global functions
 */
(function (w, d) {
    /**
     * Skips focus to element from the skip ID to specified target ID
     * @param {string} skipID
     * @param {string} targetID
     * @param {boolean} makeTargetFocusable set true if going to an element like <main>
     */
    function skipLink(skipID, targetID, makeTargetFocusable = false) {
        var target = d.getElementById(targetID);
        d.getElementById(skipID).addEventListener('click', function (e) {
            e.preventDefault();
            if (makeTargetFocusable) {
                // for elements that you need to set for focus for - e.x. <main>
                target.setAttribute('tabindex', '-1');
            }
            target.focus();
        });
    }
    // make skipLink function accessible to all JS
    w.skipLink = skipLink;
}(window, document))

// Create "window.Shoppad.apps.infiniteoptions" object to hook into app events
"Shoppad.apps.infiniteoptions".split(".").reduce(function (o, x) { if (!o[x]) { o[x] = {}; } return o[x] }, window);
window.Shoppad.apps.infiniteoptions.beforeReady = function (subscribe) {
    subscribe('appLoad', function (event) {
        var addToCartButton = document.querySelector('.product-form--atc-button');
        var isAvailable = addToCartButton.dataset.available === 'true';
        if (isAvailable) {
            addToCartButton.disabled = false;
            addToCartButton.classList.remove('disabled')
        }
    });
};

// Created a function to toggle a product description
$('.product-description-toggle').click(function (event) {
    event.preventDefault();
    var productDescription = $('.product-description');
    var detailedDescription = $('.description');
    var isFullDescription = $(this).parent(productDescription).hasClass("product-description-full");
    detailedDescription.toggleClass('product-description-partial');
    if (isFullDescription) {
        productDescription.addClass('product-description-short').removeClass('product-description-full');
    } else {
        productDescription.removeClass('product-description-short').addClass('product-description-full');
    }
});

//creates a MutationObserver that listens for changes to the modal, attaches event listeners to its +/- buttons that update the qty of a product, then disconnects the observer.
let observerInitialized = false;

const quantityObserver = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
        if (mutation.addedNodes && mutation.addedNodes.length > 0) {
            const modalInner = mutation.target.querySelector('.modal-inner');
            if (modalInner && !observerInitialized) {
                observerInitialized = true;
                $(document).on('click','.product-form__quantity-btn[data-action="decrease-product-quantity"]',function(){
                    const inputSelector = $('#product-quantity-input');
                    const inputValue = inputSelector.val();
                    const newValue = Math.max(inputValue - 1, 1);
                    inputSelector.val(newValue);
                });
                $(document).on('click', '.product-form__quantity-btn[data-action="increase-product-quantity"]', function(){
                    const inputSelector = $('#product-quantity-input');
                    const inputValue = parseInt(inputSelector.val());
                    const newValue = parseInt(Math.max(inputValue, 1)) + 1;
                    inputSelector.val(newValue);
                });
                
                quantityObserver.disconnect();
            }
        }
    });
});

const targetNode = document.body;
const config = { childList: true, subtree: true };

if (!observerInitialized) {
  quantityObserver.observe(targetNode, config);
}
